<template>
  <div
    id="analysis"
    :thirdNavigationState="thirdNavigationState"
    :thirdNavigationType="thirdNavigationType"
    :thirdNavigationSearch="thirdNavigationSearch"
    :thirdNavigationIdentify="thirdNavigationIdentify"
  >
    <el-main>
      <el-table
        ref="dataTable"
        v-show="!IsTable"
        v-loading="loading"
        :data="tableData2"
        :header-cell-style="tableHeaderColor"
        @row-click="rowClick"
        style="width: 100%"
      >
        <el-table-column
          :default-sort="{prop: 'projectName', order: 'descending'}"
          sortable
          :label="$t('table.common.projectName')"
          width="277px;"
          prop="projectName"
        >
          <template slot-scope="scope">
            <div>
              <img
                :src="scope.row.icon"
                alt
                style="width: 60px;
              height: 60px;
              padding-left: 15px;
              padding-right: 10px;
              display: inline-block;"
              >
              <span style="padding-left:10px;">{{scope.row.projectName}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          :default-sort="{prop: 'contentType', order: 'descending'}"
          sortable
          :render-header="renderHeader"
          :label="$t('table.common.projectType')"
          width="154px;"
          prop="contentType"
        ></el-table-column>

        <el-table-column
          :default-sort="{prop: 'viewSum', order: 'descending'}"
          sortable
          :label="$t('appAnalysis.table.header.search')"
          prop="viewSum"
        ></el-table-column>
        <el-table-column
          :render-header="renderHeader"
          :default-sort="{prop: 'downloadSum', order: 'ascending'}"
          sortable
          :label="$t('appAnalysis.table.header.download')"
          prop="downloadSum"
        ></el-table-column>
        <el-table-column
          :default-sort="{prop: 'retentionRates', order: 'descending'}"
          sortable
          :label="$t('appAnalysis.table.header.retentionRates')"
          prop="retentionRates"
        >
          <template slot-scope="scope">
            <div style="line-height: 40px;">
              <span>{{ scope.row.retentionRates ? scope.row.retentionRates : '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :default-sort="{prop: 'crashes', order: 'descending'}"
          sortable
          label="Crashes"
          prop="crashes"
        >
          <template slot-scope="scope">
            <div>
              <span>{{scope.row.crashes ? scope.row.crashes : '--' }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="IsTable" class="noAppAnalyDataClass">
        <p>{{ $t('appAnalysis.table.null.content.top') }}</p>
        <p>{{ $t('appAnalysis.table.null.content.bottom') }}</p>
      </div>
    </el-main>
  </div>
</template>

<script>
export default {
    data () {
        return {
            loading: false,
            tableData: [],
            tableData2: [],
            search: '',
            appId: '',
            IsTable: false
        }
    },
    mounted () {
        this.apiAnaly()
    },
    methods: {
        isScrollShowFunc (len) {
            if (len > 4) {
                this.$refs.dataTable.$el
                    .querySelector('.el-table__body-wrapper')
                    .classList.add('scrollShow')
            } else {
                this.$refs.dataTable.$el
                    .querySelector('.el-table__body-wrapper')
                    .classList.remove('scrollShow')
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: rgba(51, 51, 51, 0.08);'
            }
        },
        // 自定义渲染
        renderHeader (h, { column, $index }) {
            return (
                <div style="padding:0;display:inline;">
                    <span style="marginRight:20px;">{column.label}</span>
                </div>
            )
        },
        // get data function
        apiAnaly () {
            document.body.scrollTop = document.documentElement.scrollTop = 0
            this.loading = true
            let path = 'developer/report'
            this._api.request('get', path)
                .then(res => {
                    let data = res.data.data.payload
                    !data.length && (this.IsTable = true)
                    data.length && (this.IsTable = false)
                    this.tableData2 = data
                    this.loading = false
                    this.isScrollShowFunc(data.length)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        rowClick (row, event, column) {
            this.$router.push({
                path: '/echarts',
                query: {
                    appId: row.appId
                }
            })
            this.appId = row.appId
        },
        searchFunc (val) {
            document.body.scrollTop = document.documentElement.scrollTop = 0
            this.loading = true
            let path = `/developer/report?keyword=${val}`
            this._api.request('get', path)
                .then(res => {
                    this.tableData2 = res.data.data.payload
                    this.isScrollShowFunc(this.tableData2.length)
                    this.loading = false
                    // 搜索的filter
                    this.clearState(val)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        filterTypeFunc (type) {
            document.body.scrollTop = document.documentElement.scrollTop = 0
            this.loading = true
            let path = `/developer/report?contentType=${type}`
            this._api.request('get', path)
                .then(res => {
                    this.tableData2 = res.data.data.payload
                    this.isScrollShowFunc(this.tableData2.length)
                    this.loading = false
                })
                .catch(error => {
                    console.log(error)
                })
        },
        clearState (type) {
            if (type) {
                this.$store.state.thirdNavigationType = null
                this.$store.state.thirdNavigationState = null
            }
            this.$store.state.thirdNavigationIdentify = null
        }
    },
    watch: {
        search () {
            return this.search
        }
    },
    computed: {
        thirdNavigationState () {
            return this.$store.state.thirdNavigationState
        },
        // 类型
        thirdNavigationType () {
            return this.$store.state.thirdNavigationType
        },
        thirdNavigationIdentify () {
            let type = this.$store.state.thirdNavigationIdentify
            if (type && this.$store.state.isFlagSpanClass === 'appAnalysis') {
                if (type === 'search') {
                    this.thirdNavigationSearch &&
                        this.searchFunc(this.thirdNavigationSearch)
                    !this.thirdNavigationSearch && this.apiAnaly()
                } else if (this.thirdNavigationType) {
                    this.filterTypeFunc(this.thirdNavigationType)
                } else {
                    this.apiAnaly()
                }
                this.clearState()
            }
            return this.$store.state.thirdNavigationIdentify
        },
        thirdNavigationSearch () {
            return this.$store.state.thirdNavigationSearch
        }
    },
    destroyed () {
        this.clearState('destroyed')
    }
}
</script>
<style scoped>
* {
    margin: 0px;
}
#analysis {
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #333333;
    background-color: rgba(51, 51, 51, 0.05);
    height: 780px;
}
.noAppAnalyDataClass {
    width: 500px;
    font-size: 14px;
    letter-spacing: 0.8px;
    text-align: center;
    color: #333333;
    margin: auto;
    margin-top: 150px;
}
.noAppAnalyDataClass p {
    margin-bottom: 4px;
}
img {
    vertical-align: middle;
}
._input {
    border-radius: 3px;
    outline: none !important;
}
._div {
    display: inline-block;
    width: 200px;
    /* margin-left: 30px; */
    position: relative;
}

._sprite_class {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-image: url('../../assets/img/search.png');
    position: absolute;
    left: 8px;
    top: 0px;
    cursor: pointer;
    text-align: center;
}
._el_dropdown {
    display: inline-block;
}
</style>
<style>
td {
    background-clip: padding-box;
}
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
#analysis ::-webkit-scrollbar {
    width: 10px; /*对垂直流动条有效*/
    height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
#analysis ::-webkit-scrollbar-track {
    /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
    background-color: rgba(51, 51, 51, 0.2);
    border-radius: 3px;
}
/*定义滑块颜色、内阴影及圆角*/
#analysis ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.8);
}
#analysis .scrollShow {
    overflow-y: scroll !important;
    height: 400px;
    overflow-x: hidden !important;
}
#analysis .el-dropdown-link {
    cursor: pointer;
}
#analysis .el-icon-arrow-down {
    font-size: 14px;
    width: 6px;
    height: 10.1px;
    font-weight: 1000;
    color: #323246;
}

#analysis .el-table th.is-leaf,
.el-table td {
    border-bottom: 1px solid #d8d8d8 !important;
}

#analysis .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(0, 224, 218, 0.05) !important;
    cursor: pointer;
}
#analysis .el-table .cell {
    /* font-weight: normal; */
    padding: 0px;
}

#analysis .el-table tr {
    /* height: 90px; */
    box-sizing: border-box;
}
#analysis .el-table tr:last-child > td {
    /* height: 90px; */
    border-bottom: none !important;
}
#analysis .el-main {
    padding: 193px 0px 155px 0px;
}
#analysis .el-table--fit {
    border-right: 0;
    width: 901px !important;
    margin: auto;
    width: 896px !important;
    margin: auto;
    border: 1px solid rgba(51, 51, 51, 0.2);
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}
#analysis .el-table td {
    padding: 15px 0px !important;
    width: 161px;
    height: 60px;
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #333333;
}
#analysis .el-table th,
.el-table td {
    padding: 0px !important;
}
#analysis .el-table th:nth-child(1) .cell {
    text-align: center;
}
#analysis .el-table th > .cell {
    padding: 0px;
    text-align: left;
    font-weight: 600;
    line-height: 40px;
}
#analysis .el-dropdown {
    left: 94px;
    width: 100px;
}
#analysis .el-table__header-wrapper,
.el-table__footer-wrapper {
    background-color: rgba(51, 51, 51, 0.08);
    line-height: 40px;
}
#analysis .el-table thead {
    width: 30px;
    height: 20px;
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #333333 !important;
}
#analysis .el-input--mini .el-input__inner {
    padding-left: 36px;
    width: 170px;
}

#analysis .el-table__header {
    border-bottom: none;
}
#analysis .el-table__header {
    border-bottom: none;
}
#analysis .el-table--border::after,
.el-table--group::after,
.el-table::before {
    display: none;
}
</style>
